define('DisplayCommerceCategoryFields.SS2Model', [
  'SCModel',
  'Utils'
], function (SCModelComponent, Utils) {
  'use strict';

  var SCModel = SCModelComponent.SCModel;

  function DisplayCommerceCategoryFieldsSS2Model() {
    SCModel.call(this);

    this.urlRoot = function () {
      return Utils.getAbsoluteUrl(
        getExtensionAssetsPath('Modules/DisplayCommerceCategoryFields/SuiteScript2/DisplayCommerceCategoryFields.Service.ss'), true
      );
    };
  }

  DisplayCommerceCategoryFieldsSS2Model.prototype = Object.create(SCModel.prototype);

  DisplayCommerceCategoryFieldsSS2Model.prototype.constructor = DisplayCommerceCategoryFieldsSS2Model;

  return DisplayCommerceCategoryFieldsSS2Model;
}
);
